// @flow
import Control from 'ol/control/control';
import ol from 'ol';

const customControl = function (args) {
    let options = args || {};
    let button = document.createElement('button');
    button.innerHTML = options.innerHTML;

    var handleClick = function (e) {
        options.onClick(options.parent);
    };

    button.addEventListener('click', handleClick, false);
    button.addEventListener('touchstart', handleClick, false);

    var element = document.createElement('div');
    element.className = (options.className || ' ') + ' ol-unselectable ol-control';
    element.appendChild(button);
    element.title = options.title;

    this.ref = button;
    Control.call(this, {
        element: element,
        target: options.target
    });
}

ol.inherits(customControl, Control);

export default customControl;


// WEBPACK FOOTER //
// ./src/containers/content/map/popups/customControl.js